import React from "react";
import { FooterDesktop } from "./pageFooterDesktop.element";
import { FooterMobile } from "./pageFooterMobile.element";
export const Footer = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(FooterDesktop, null),
        React.createElement(FooterMobile, null)));
};
